import { EEnvCountry, EEnvLocale } from 'affiny-core/env.types';
import { EGender } from 'affiny-core/modules/account/types';
import { EBrand } from 'affiny-core/types/env.types';

enum EEVENT_CATEGORY {
  USER_INTERACTION = 'USER_INTERACTION',
}

enum EEVENT_ACTION {
  SEND = 'Send',
}

export enum EEVENT_LABEL {
  CANCELRA_CLICK_CTA_CONFIRMATION = 'CANCELRA_CLICK_CTA_CONFIRMATION',
  COMPAT_REPORT_TAB_CLICK_ON_PERSONALITY = 'COMPAT_REPORT_TAB_CLICK_ON_PERSONALITY',
  COMPAT_REPORT_TAB_CLICK_ON_VALUE = 'COMPAT_REPORT_TAB_CLICK_ON_VALUE',
  COMPAT_REPORT_TAB_CLICK_ON_VISION = 'COMPAT_REPORT_TAB_CLICK_ON_VISION',
  COMPATIBILITY_CARD = 'COMPATIBILITY_CARD',
  COMPATIBILITY_MINI_CARD = 'COMPATIBILITY_MINI_CARD',
  FULLPAGE_MEMBER_CARD_DECLINE = 'FULLPAGE_MEMBER_CARD_DECLINE',
  FULLPAGE_MEMBER_CARD_FAVORITE = 'FULLPAGE_MEMBER_CARD_FAVORITE',
  MESSAGE_CLICK = 'MESSAGE_CLICK',
  MESSAGE_FROM_COMPAT_REPORT = 'MESSAGE_FROM_COMPAT_REPORT',
  MESSAGE_FROM_PROFILE = 'MESSAGE_FROM_PROFILE',
  PERSONALITY_REPORT_FROM_MODAL = 'PERSONALITY_REPORT_FROM_MODAL',
  PERSONALITY_REPORT_FROM_PROFILE = 'PERSONALITY_REPORT_FROM_PROFILE',
  SPECIAL_OFFER_SKIP = 'SPECIAL_OFFER_SKIP',
  SPECIAL_OFFER_SUBSCRIBE = 'SPECIAL_OFFER_SUBSCRIBE',
  AFFINY_LOGO_CLICK = 'AFFINY_LOGO_CLICK',
  NAV_SELECTION_CLICK = 'SELECTION_CLICK',
  NAV_LIST_CLICK = 'LIST_CLICK',
  NAV_MESSAGES_CLICK = 'MESSAGES_CLICK',
  NAV_FAVORITES_CLICK = 'FAVORIS_CLICK',
  NAV_VISITES_CLICK = 'VISITES_CLICK',
  NAV_PHOTOS_CLICK = 'PHOTOS_CLICK',
  NAV_MY_PROFILE_CLICK = 'MY_PROFILE_CLICK',
  FOOTER_WHOWEARE_CLICK = 'FOOTER_WHOWEARE_CLICK',
  FOOTER_CONDITIONS_CLICK = 'FOOTER_CONDITIONS_CLICK',
  FOOTER_PRIVACY_CLICK = 'FOOTER_PRIVACY_CLICK',
  FOOTER_ENGAGEMENTS_CLICK = 'FOOTER_ENGAGEMENTS_CLICK',
  FOOTER_HELP_CLICK = 'FOOTER_HELP_CLICK',
  FOOTER_COOKIE_POLICY_CLICK = 'FOOTER_COOKIE_POLICY_CLICK',
  FAV_RECEIVED_CLICK = 'FAV_RECEIVED_CLICK',
  FAV_SENT_CLICK = 'FAV_SENT_CLICK',
  FAV_MESSAGE_FROM_FAVLIST_RECEIVED = 'MESSAGE_FROM_FAVLIST_RECEIVED',
  FAV_MESSAGE_FROM_FAVLIST_SENT = 'MESSAGE_FROM_FAVLIST_SENT',
  FAV_CARD_FROM_FAVLIST_CLICK = 'CARD_FROM_FAVLIST_CLICK',
  FAV_EMPTY_FAVLIST_CTA = 'EMPTY_FAVLIST_CTA',
  VISITS_MESSAGE_FROM_VISITLIST = 'MESSAGE_FROM_VISITLIST',
  VISITS_CARD_FROM_VISITLIST_CLICK = 'CARD_FROM_VISITLIST_CLICK',
  VISITS_EMPTY_VISITLIST_CTA = 'EMPTY_VISITLIST_CTA',

  // profile-edit component
  YOURPROFILE_CLICK_PROFILE_PIC = 'YOURPROFILE_CLICK_PROFILE_PIC',
  YOURPROFILE_CLICK_GALLERY = 'YOURPROFILE_CLICK_GALLERY',
  YOURPROFILE_CLICK_KEBAB_MENU = 'YOURPROFILE_CLICK_KEBAB_MENU',
  YOURPROFILE_CLICK_DELETE_PHOTO = 'YOURPROFILE_CLICK_DELETE_PHOTO',
  YOURPROFILE_CLICK_CHOOSE_AS_PP = 'YOURPROFILE_CLICK_CHOOSE_AS_PP',
  YOURPROFILE_CLICK_ADD_PHOTO = 'YOURPROFILE_CLICK_ADD_PHOTO',
  ADD_PHOTO_CLICK_ADD_FROM_COMPUTER = 'ADD_PHOTO_CLICK_ADD_FROM_COMPUTER',
  ADD_PHOTO_CLICK_CTA_CANCEL = 'ADD_PHOTO_CLICK_CTA_CANCEL',
  ADD_PHOTO_CLICK_CTA_VALIDATE = 'ADD_PHOTO_CLICK_CTA_VALIDATE',
  ADD_PHOTO_CLICK_CLOSE = 'ADD_PHOTO_CLICK_CLOSE',
  ADD_PHOTO_CLICK_OUTSIDE_POPIN = 'ADD_PHOTO_CLICK_OUTSIDE_POPIN',
  PRIVPUBMODE_CLICK_CTA_GEREZ = 'PRIVPUBMODE_CLICK_CTA_GEREZ',
  PRIVPUBMODE_CLICK_PRIVATE_MODE_CARD = 'PRIVPUBMODE_CLICK_PRIVATE_MODE_CARD',
  PRIVPUBMODE_CLICK_PUBLIC_MODE_CARD = 'PRIVPUBMODE_CLICK_PUBLIC_MODE_CARD',
  PRIVPUBMODE_CLICK_CLOSE_POPIN = 'PRIVPUBMODE_CLICK_CLOSE_POPIN',
  PRIVPUBMODE_CLICK_OUTSIDE_POPIN = 'PRIVPUBMODE_CLICK_OUTSIDE_POPIN',
  PHOTOREQUEST__BREAKER_REG_CLICK_CTA = 'PHOTOREQUEST__BREAKER_REG_CLICK_CTA',
  MODIFYSUMMARY_CLICK_CTA_MODIFY = 'MODIFYSUMMARY_CLICK_CTA_MODIFY',
  MODIFYSUMMARY_CLICK_WRITE_INPUT = 'MODIFYSUMMARY_CLICK_WRITE_INPUT',
  MODIFYSUMMARY_CLICK_CTA_VALIDATE = 'MODIFYSUMMARY_CLICK_CTA_VALIDATE',
  MODIFYSUMMARY_CLICK_CLOSE_POPIN = 'MODIFYSUMMARY_CLICK_CLOSE_POPIN',
  MODIFYSUMMARY_CLICK_OUTSIDE_POPIN = 'MODIFYSUMMARY_CLICK_OUTSIDE_POPIN',
  PRIVMODE_BREAKER_REG_CLICK_CTA = 'PRIVMODE_BREAKER_REG_CLICK_CTA',
  MYPROFILE_MODIF_INFO_HEADER = 'MYPROFILE_MODIF_INFO_HEADER',
  MYPROFILE_MODIF_INTEREST = 'MYPROFILE_MODIF_INTEREST',
  MYPROFILE_MODIF_VISION = 'MYPROFILE_MODIF_VISION',
  MYPROFILE_MODIF_TASTE = 'MYPROFILE_MODIF_TASTE',
  MYPROFILE_MODIF_ASPIRATION = 'MYPROFILE_MODIF_ASPIRATION',
  MYPROFILE_MODIF_INFORMATIONS = 'MYPROFILE_MODIF_INFORMATIONS',
  MYPROFILE_MODIF_COMPLEMENTORY = 'MYPROFILE_MODIF_COMPLEMENTORY',
  MYPROFILE_SAVE_INFO_HEADER = 'MYPROFILE_SAVE_INFO_HEADER',
  MYPROFILE_SAVE_INTEREST = 'MYPROFILE_SAVE_INTEREST',
  MYPROFILE_SAVE_VISION = 'MYPROFILE_SAVE_VISION',
  MYPROFILE_SAVE_TASTE = 'MYPROFILE_SAVE_TASTE',
  MYPROFILE_SAVE_ASPIRATION = 'MYPROFILE_SAVE_ASPIRATION',
  MYPROFILE_SAVE_INFORMATIONS = 'MYPROFILE_SAVE_INFORMATIONS',
  MYPROFILE_SAVE_COMPLEMENTORY = 'MYPROFILE_SAVE_COMPLEMENTORY',

  // Discover
  DISCOVER_PERSONAL_ASP_CLICK_NAV_ARROW = 'DISCOVER_PERSONAL_ASP_CLICK_NAV_ARROW',
  DISCOVER_PERSONAL_ASP_CLICK_CARD = 'DISCOVER_PERSONAL_ASP_CLICK_CARD',
  KEBABMENU_CLICK_FROM_DISCOVER = 'KEBABMENU_CLICK_FROM_DISCOVER',
  KEBABMENU_LIST_BLOCKUSER_FROM_DISCOVER = 'KEBABMENU_LIST_BLOCKUSER_FROM_DISCOVER',
  KEBABMENU_LIST_REPORTUSER_FROM_DISCOVER = 'KEBABMENU_LIST_REPORTUSER_FROM_DISCOVER',
  DISCOVER_GALLERY_BREAKER_REG_CLICK_CTA = 'DISCOVER_GALLERY_BREAKER_REG_CLICK_CTA',
  DISCOVER_RIGHTCOLUMN_BREAKER_REG_CLICK_CTA = 'DISCOVER_RIGHTCOLUMN_BREAKER_REG_CLICK_CTA',
  DISCOVER_MINIATURE_CLICK = 'DISCOVER_MINIATURE_CLICK',
  DISCOVER_HEADER_CLICK = 'DISCOVER_HEADER_CLICK',
  DISCOVER_PHOTO_GALLERY_CLICK = 'DISCOVER_PHOTO_GALLERY_CLICK',
  DISCOVER_MESSAGE_FROM_DISCOVER = 'MESSAGE_FROM_DISCOVER',
  DISCOVER_CLICK_SEARCH_CRITERIAS = 'DISCOVER_CLICK_SEARCH_CRITERIAS',
  CTA_MESSAGE_FROM_POPUP = 'CTA_MESSAGE_FROM_POP-UP',
  BREAKER_FOR_FTA = 'BREAKER_FOR_FTA',
  DISCOVER_INPUT_MESSAGE = 'DISCOVER_INPUT_MESSAGE',
  MESSAGE_DISCOVER_SEND = 'MESSAGE_DISCOVER_SEND',
  MESSAGE_AFTER_FAV = 'MESSAGE_AFTER_FAV',
  INPUT_AFTER_FAV = 'INPUT_AFTER_FAV',
  NEXT_AFTER_FAV = 'NEXT_AFTER_FAV',
  PROFILE_DISCOVER_REPORT_HEADER = 'PROFILE_DISCOVER_REPORT_HEADER',
  PROFILE_DISCOVER_REPORT_BREAKER = 'PROFILE_DISCOVER_REPORT_BREAKER',
  PROFILE_DISCOVER_REPORT_CTA = 'PROFILE_DISCOVER_REPORT_CTA',

  // Inbox
  KEBABMENU_CLICK_FROM_INBOX = 'KEBABMENU_CLICK_FROM_INBOX',
  KEBABMENU_LIST_BLOCKUSER_FROM_INBOX = 'KEBABMENU_LIST_BLOCKUSER_FROM_INBOX',
  KEBABMENU_LIST_REPORTUSER_FROM_INBOX = 'KEBABMENU_LIST_REPORTUSER_ FROM_INBOX',
  INBOX_BREAKER_BLACKLIST_CLICK_CTA_I_UNDERSTOOD = 'INBOX_BREAKER_BLACKLIST_CLICK_CTA_I_UNDERSTOOD',
  INBOX_VIEWPROFILE_CLICK = 'INBOX_VIEWPROFILE_CLICK',
  INBOX_HEADER_THREAD_CLICK = 'INBOX_HEADER_THREAD_CLICK',
  INBOX_CONVLIST_CLICK = 'INBOX_CONVLIST_CLICK',
  INBOX_MESSAGE_INPUT_CLICK = 'INBOX_MESSAGE_INPUT_CLICK',
  INBOX_SEND_BUTTON_CLICK = 'INBOX_SEND_BUTTON_ CLICK',
  INBOX_EMPTY_INBOX_CTA = 'INBOX_EMPTY_INBOX_CTA',
  NP_SO_ON_SITE_INBOX_EMPTY = 'NP_SO_ON_SITE_INBOX_EMPTY',

  // Profile display
  KEBABMENU_CLICK_FROM_PD = 'KEBABMENU_CLICK_FROM_PD',
  KEBABMENU_LIST_BLOCKUSER_FROM_PD = 'KEBABMENU_LIST_BLOCKUSER_FROM_PD',
  KEBABMENU_LIST_REPORTUSER_FROM_PD = 'KEBABMENU_LIST_REPORTUSER_FROM_PD',
  PD_PERSONAL_ASP_CLICK_NAV_ARROW = 'PD_PERSONAL_ASP_CLICK_NAV_ARROW',
  PD_PERSONAL_ASP_CLICK_CARD = 'PD_PERSONAL_ASP_CLICK_CARD',
  PHOTO_REQUEST_FROM_PD = 'PHOTO_REQUEST_FROM_PD',
  PHOTO_REQUEST_FROM_GALLERY = 'PHOTO_REQUEST_FROM_GALLERY',
  PROFILE_PICTURE_CLICK = 'PROFILE_PICTURE_CLICK',
  PROFILE_MESSAGE_FROM_PROFILE = 'MESSAGE_FROM_PROFILE',
  PROFILE_ADD_FAV_FROM_PROFILE = 'ADD_FAV_FROM_PROFILE',
  PROFILE_ANNOUNCE_SEE_MORE_CLICK = 'PROFILE_ANNOUNCE_SEE_MORE_CLICK',
  PROFILE_PHOTO_GALLERY_CLICK = 'PROFILE_PHOTO_GALLERY_CLICK',
  PROFILE_INPUT_MESSAGE = 'PROFILE_INPUT_MESSAGE',
  PROFILE_FOOTER_FAV = 'PROFILE_FOOTER_FAV',
  MESSAGE_AFTER_FAV_PROFILE = 'MESSAGE_AFTER_FAV_PROFILE',
  INPUT_AFTER_FAV_PROFILE = 'INPUT_AFTER_FAV_PROFILE',
  MESSAGE_PROFILE_SEND = 'MESSAGE_PROFILE_SEND',
  BREAKER_SUB_PROFILE = 'BREAKER_SUB_PROFILE',
  PROFILE_DISPLAY_REPORT_HEADER = 'PROFILE_DISPLAY_REPORT_HEADER',
  PROFILE_DISPLAY_REPORT_BREAKER = 'PROFILE_DISPLAY_REPORT_BREAKER',
  PROFILE_DISPLAY_REPORT_CTA = 'PROFILE_DISPLAY_REPORT_CTA',

  // Photo request / photo reveal
  PHOTO_REQUEST_CLICK_PROFILE_CARD = 'PHOTO_REQUEST_CLICK_PROFILE_CARD',
  PHOTO_REQUEST_CLICK_CARD_DISCOVER_PROFILE = 'PHOTO_REQUEST_CLICK_CARD_DISCOVER_PROFILE',
  PHOTO_REQUEST_CLICK_CTA_YES = 'PHOTO_REQUEST_CLICK_CTA_YES',
  PHOTO_REQUEST_CLICK_CTA_NO = 'PHOTO_REQUEST_CLICK_CTA_NO',
  PHOTO_REQUEST_BREAKER_REG_CLICK_CTA = 'PHOTO_REQUEST_BREAKER_REG_CLICK_CTA',

  // Page explore
  EXPLORE_FILTERS_CLICK_BEST_SCORES = 'EXPLORE_FILTERS_CLICK_BEST_SCORES',
  EXPLORE_FILTERS_CLICK_SUB_DATE = 'EXPLORE_FILTERS_CLICK_SUB_DATE',
  EXPLORE_FILTERS_CLICK_ASCENDING_AGE = 'EXPLORE_FILTERS_CLICK_ASCENDING_AGE',
  EXPLORE_FILTERS_CLICK_DESCENDING_AGE = 'EXPLORE_FILTERS_CLICK_DESCENDING_AGE',
  EXPLORE_CLICK_PROFILE_CARD = 'EXPLORE_CLICK_PROFILE_CARD',
  MESSAGE_FROM_EXPLORE = 'MESSAGE_FROM_EXPLORE',
  ADD_FAV_FROM_EXPLORE = 'ADD_FAV_FROM_EXPLORE',
  EXPLORE_PROFILE_CARD_CLICK_DISCOVER_PROFILE = 'EXPLORE_PROFILE_CARD_CLICK_DISCOVER_PROFILE',
  REACTIVATERA_CLICK_CTA_REACTIVATE = 'REACTIVATERA_CLICK_CTA_REACTIVATE',
  EXPLORE_CLICK_SEARCH_CRITERIAS = 'EXPLORE_CLICK_SEARCH_CRITERIAS',

  // Recent activities component
  RECENT_ACTIVITY_CLICK_ON_MESSAGES = 'RECENT_ACTIVITY_CLICK_ON_MESSAGES',
  RECENT_ACTIVITY_CLICK_ON_VISITS = 'RECENT_ACTIVITY_CLICK_ON_VISITS',
  RECENT_ACTIVITY_CLICK_ON_FAV = 'RECENT_ACTIVITY_CLICK_ON_FAV',
  RECENT_ACTIVITY_CLICK_ON_PHOTOREQUEST = 'RECENT_ACTIVITY_CLICK_ON_PHOTOREQUEST',

  // Blacklist flow
  BLACKLIST_CLICK_CTA_BLOCK_PROFILE = 'BLACKLIST_CLICK_CTA_BLOCK_PROFILE',
  BLACKLIST_CLICK_CLOSE_POPIN = 'BLACKLIST_CLICK_CLOSE_POPIN',
  BLACKLIST_CLICK_OUTSIDE_POPIN = 'BLACKLIST_CLICK_OUTSIDE_POPIN',
  BLACKLIST_CLICK_REPORT_USER = 'BLACKLIST_CLICK_REPORT_USER',

  // Report user
  REPORTUSER_CLICK_DESCRIBE_INPUT = 'REPORTUSER_CLICK_DESCRIBE_INPUT',
  REPORTUSER_CLICK_CTA_SEND = 'REPORTUSER_CLICK_CTA_SEND',
  REPORTUSER_CLICK_TEXTLINK_HELP = 'REPORTUSER_CLICK_TEXTLINK_HELP',
  REPORTUSER_CLICK_CLOSE_POPIN = 'REPORTUSER_CLICK_CLOSE_POPIN',
  REPORTUSER_CLICK_OUTSIDE_POPIN = 'REPORTUSER_CLICK_OUTSIDE_POPIN',
  REPORTUSER_CLICK_BLOCK_USER = 'REPORTUSER_CLICK_BLOCK_USER',

  // Pc announce
  PC_DESKTOP_IMPORT_ADD = 'PC_DESKTOP_IMPORT_ADD',
  PC_MOBILE_IMPORT_ADD = 'PC_MOBILE_IMPORT_ADD',

  // Pc brand and market
  PC_BRAND = 'PC_BRAND',
  PC_MARKET = 'PC_MARKET',
  PC_REGULAR = 'PC_REGULAR',

  // XSell legal page
  XSELL_WITH_MARKETING_CONTENT = 'XSELL_WITH_MARKETING_CONTENT',
}

export interface IAnalyticsEvent {
  eventCategory: EEVENT_CATEGORY;
  eventAction: EEVENT_ACTION;
  eventLabel: EEVENT_LABEL;
}

export interface IAnalyticsStrategy {
  trackPageView(page: string): void;
  trackEvent(event: IAnalyticsEvent): void;
  pushUserInfos(userInfos: IAnalyticsInfoUser): void;
}

export interface IAnalyticsInfoUser {
  hashedAccountId?: string;
  ageRange?: string;
  gender: EGender;
  isSub: boolean;
  site_country: EEnvCountry;
  site_language: EEnvLocale;
  site_version: 'desktop_web' | 'mobile_web';
  brand_name?: EBrand;
}

// this class is currently only used in affiny-mobile for Analytics tracking
class Analytics {
  private instance: IAnalyticsStrategy;

  public configure = (value: IAnalyticsStrategy): void => {
    this.instance = value;
  };

  public addInfo = (value: IAnalyticsInfoUser): void => {
    this.instance.pushUserInfos(value);
  };

  public get strategy(): IAnalyticsStrategy {
    if (!this.instance) {
      throw new Error(
        'affiny-core/analytics.ts you cannot call .strategy before configure it. Search Analytics.configure() method'
      );
    }

    return this.instance;
  }

  public trackPageView(page: string) {
    this.instance.trackPageView(page);
  }

  public trackEvent(
    eventLabel: EEVENT_LABEL,
    eventCategory: EEVENT_CATEGORY = EEVENT_CATEGORY.USER_INTERACTION,
    eventAction: EEVENT_ACTION = EEVENT_ACTION.SEND
  ) {
    this.instance.trackEvent({
      eventLabel,
      eventCategory,
      eventAction,
    });
  }
}

export const analytics = new Analytics();
